import Vue from 'vue'
import Router from 'vue-router'
import VueRouterBackButton from 'vue-router-back-button'
import Security from '@/plugins/security'

const Home = () => import('@/views/Home')
const AgreementShow = () => import('@/views/agreement/Show')
const PageNotFound = () => import('@/views/error/PageNotFound')
const GenericError = () => import('@/views/error/GenericError')
const Forbidden = () => import('@/views/error/Forbidden')
const AuthCallback = () => import('./views/AuthCallback')
const Support = () => import('@/views/Support')
const OrderList = () => import('@/views/order/List')
const OrderShow = () => import('@/views/order/Show')
const PaymentMethodList = () => import('@/views/payment_method/List')
const VpnShow = () => import('@/views/vpn/Vpn')

Vue.use(Router)
Vue.use(Security)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/orders',
      name: 'orders',
      component: OrderList
    },
    {
      path: '/order/:id',
      name: 'order',
      component: OrderShow
    },
    {
      path: '/support',
      name: 'support',
      component: Support
    },
    {
      path: '/agreement/:id',
      name: 'AgreementShow',
      component: AgreementShow
    },
    {
      path: '/payment-methods',
      name: 'paymentMethods',
      component: PaymentMethodList
    },
    {
      path: '/vpn/:id',
      name: 'VpnShow',
      component: VpnShow
    },
    {
      name: 'logout',
      path: '/logout',
      beforeEnter: () => {
        localStorage.removeItem('user')
        Vue.keycloak.logout()
      }
    },
    {
      name: 'authCallback',
      path: '/auth-callback',
      component: AuthCallback
    },
    {
      name: 'pageNotFound',
      path: '*',
      component: PageNotFound
    },
    {
      name: 'genericError',
      path: '*',
      component: GenericError
    },
    {
      name: 'forbiddenError',
      path: '*',
      component: Forbidden
    }
  ]
})

const notAuthRoutes = ['logout', 'authCallback', 'pageNotFound', 'genericError', 'forbiddenError']

router.beforeEach((to, from, next) => {
  if (notAuthRoutes.includes(to.path) || notAuthRoutes.includes(to.name)) {
    next()
    return
  }

  if (
    !Vue.security.getUser() ||
    !Vue.keycloak.authenticated ||
    Vue.keycloak.tokenParsed.sub !== Vue.security.getUser().sub
  ) {
    Vue.keycloak.login({
      redirectUri: window.origin + '/auth-callback'
    })
  }

  if (Vue.security.isAllowed()) {
    next()
  } else {
    next({ name: 'forbiddenError', params: [to.path], replace: true })
  }
})

export function isNoAuthRoute() {
  return notAuthRoutes.includes(router.currentRoute.path) || notAuthRoutes.includes(router.currentRoute.name)
}

Vue.use(VueRouterBackButton, { router })

export default router
